import { useBadgingTranslation } from '../../../../../ui/hooks';
import { TextCell } from '@juvare/common-data-table-ui/DataTable';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Stack, Typography } from '@mui/material';
import React from 'react';
import { getAccountBadgeStatusDateText } from '../../utils/getAccountBadgeStatusDateText';
import { AccountBadgeStatusLabel } from '../AccountBadgeStatusLabel';
export const AccountBadgeStatusCell = ({ status, statusReasonTitle, expiresAt, statusLastUpdatedAt }) => {
    const { t } = useBadgingTranslation();
    const statusDateText = getAccountBadgeStatusDateText(t, status, expiresAt, statusLastUpdatedAt);
    return (React.createElement(TextCell, null,
        React.createElement(Stack, { direction: 'column', gap: 1 },
            React.createElement(AccountBadgeStatusLabel, { status: status, statusReasonTitle: statusReasonTitle }),
            React.createElement(Typography, { variant: 'body2', color: themeColors.text.subtle }, statusDateText))));
};
